<template>
  <div>
    <el-card shadow="never">
      <div>
        <span style="font-size: 18px; font-weight: 700; margin-right: 10px"
          >項目</span
        >
        <el-select
          v-model="workshopProjectIds"
          multiple
          placeholder=""
          style="width: 500px; margin-right: 10px"
          :multiple-limit="10"
        >
          <el-option
            v-for="item in workshopProject"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
            <span style="float: left; font-weight: bold">{{ item.label }}</span>
            <span style="float: right; font-weight: bold">{{
              item.value
            }}</span>
          </el-option>
        </el-select>
        <el-button type="primary" @click="search">搜索</el-button>
      </div>
    </el-card>
    <el-card
      shadow="never"
      class="content"
      v-for="(itmes, index) in dataList"
      :key="index"
    >
      <StatViewItmes
        :time="time"
        :workshopProjectId="itmes.workshopProjectIds"
      ></StatViewItmes>
    </el-card>
  </div>
</template>
<script>
import StatViewItmes from "./components/StatViewItmes.vue";
export default {
  components: { StatViewItmes },
  computed: {},
  data() {
    return {
      workshopProjectIds: [],
      workshopProject: [],
      workshopProcessTypes: [
        {
          value: "FC101",
          label: "机械类",
        },
        {
          value: "FC104",
          label: "电气类",
        },
        {
          value: "FC108",
          label: "调试类",
        },
      ],
      dataList: [],
      time:1
    };
  },
  methods: {
    getWorkshopProject() {
      this.ccRequest
        .do(
          "admin/fsb/workshop/project/query",
          {
            pageNo: 1,
            pageSize: 100000,
            isAsc: false,
          },
          "GET"
        )
        .then((res) => {
          let workshopProject = [];
          for (let index = 0; index < res.rows.length; index++) {
            workshopProject.push({
              value: res.rows[index].id,
              label: res.rows[index].name,
            });
          }
          this.workshopProject = workshopProject;
          this.workshopProjectIds = [res.rows[0].id];
          this.dataList.push({
            workshopProjectIds: res.rows[0].id,
          });
        })
        .catch((res) => {
          this.$message({
            type: "danger",
            message: res.response.data.message,
          });
        });
    },
    search() {
      let dataList = [];
      this.dataList = [];
      for (let index = 0; index < this.workshopProjectIds.length; index++) {
        dataList.push({
          workshopProjectIds: this.workshopProjectIds[index],
          workshopProjectName: "",
        });
      }
      this.dataList = dataList;
      this.time=new Date().getTime()
    },
  },
  mounted() {
    this.getWorkshopProject();
  },
};
</script>
<style scoped lang="scss">
</style>